import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorShow from "./ErrorShow";
import Login from "./Login/Login";


import TokenInit from "./Tokenization-x/TokenInit";
import TokenPay from "./Tokenization-x/TokenPay";
import OtpPay from "./Tokenization-x/OtpPay";
import Init from "./Payment/Init";
import CardPaymentRedirect from "./Payment/CardPaymentRedirect";


const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/pay" element={<Login />} />
        
        {/* Payment / Landing Page */}
        <Route path="/payment" element={<Init />} />
        
        {/* Card Payment Redirect */}
        <Route path="/payment/cbl" element={<CardPaymentRedirect />} />

        <Route path="/token-init" element={<TokenInit />} />
        <Route path="/token-pay" element={<TokenPay />} />
        <Route path="/otp-pay" element={<OtpPay />} />
        <Route path="error" element={<ErrorShow />} />
        
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
